<template>
  <!-- 弹出框 -->
  <a-modal
    v-model="modal.visible"
    :title="modal.title"
    :width="800"
    @ok="handleOk"
    @cancel="cancel"
    :confirm-loading="confirmLoading"
  >
    <a-form-model
      ref="ruleForm"
      :model="formData"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-row :gutter="24">
        <a-col :sm="24" :md="12">
          <a-form-model-item label="api名称" prop="apiName"
            ><a-input v-model="formData.apiName" :maxLength="50"
          /></a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="12">
          <a-form-model-item label="api路径" prop="apiUrl"
            ><a-input v-model="formData.apiUrl" :maxLength="50"
          /></a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 21 }"
            label="备注"
            prop="remark"
            ><a-input v-model="formData.remark" type="textarea"
          /></a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 21 }"
            label="排序"
            prop="listOrder"
          >
            <a-input-number
              v-model="formData.listOrder"
              :min="1"
              :max="99999"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            label="是否停用"
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 12 }"
          >
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="formData.isHalt == 'T' ? true : false"
              @change="onChange('isHalt')"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            label="是否校验登录"
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 12 }"
          >
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="formData.isCheckLogin == 'T' ? true : false"
              @change="onChange('isCheckLogin')"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: "SystemServiceApiInfo",
  props: {
    serviceCode: {
      type: String,
      default: function() {
        return "";
      }
    }
  },
  data() {
    return {
      confirmLoading: false,
      //弹出框参数
      modal: {
        visible: false,
        title: "",
        type: "add"
      },
      //form
      formData: {
        serviceCode: "",
        apiName: "",
        apiUrl: "",
        remark: "",
        isHalt: "F",
        isCheckLogin: "T",
        listOrder: 1
      },
      //form rules
      rules: {
        apiName: [
          {
            required: true,
            message: "请输入api名称",
            trigger: "change"
          }
        ],
        apiUrl: [
          {
            required: true,
            message: "请输入api路径",
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {},
  methods: {
    showModal(type, data) {
      this.modal.visible = true;
      this.modal.title = type == "add" ? "添加服务" : "编辑服务";
      this.modal.type = type;
      if (data && type == "edit") {
        this.formData = Object.assign({}, data);
      }
    },
    onChange(column) {
      if (this.formData[column] == "T") {
        this.formData[column] = "F";
      } else {
        this.formData[column] = "T";
      }
    },
    cancel() {
      this.formData = {
        serviceCode: "",
        apiName: "",
        apiUrl: "",
        remark: "",
        isHalt: "F",
        isCheckLogin: "T",
        listOrder: 1
      };
      this.confirmLoading = false;
      this.$refs.ruleForm.resetFields();
      this.modal.visible = false;
    },
    /**
     * 保存
     */
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let param = Object.assign({}, this.formData);
          param.serviceCode = this.serviceCode;
          this.confirmLoading = true;
          let action = "saveSystemServiceApi";
          if (this.modal.type == "edit") {
            action = "modifySystemServiceApi";
          }
          this.$http.systemBksApi[action](param)
            .then(res => {
              if (res.result == 0) {
                this.cancel();
                this.$emit("success");
                this.$message.success(res.msg);
              }
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="less">
.default .ant-form-item-label {
  word-break: break-all;
  word-break: normal;
  white-space: pre-wrap;
  line-height: 25px;
}
</style>
